import { useState, useEffect } from "react";
import { Star, Quote, Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { fetchTestimonials, Testimonial } from "@/lib/api";

export function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const data = await fetchTestimonials();
      setTestimonials(data);
      setLoading(false);
    }
    load();
  }, []);

  return (
    <section id="testimoni" className="py-16 lg:py-24 bg-card">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Testimoni <span className="text-gradient">Pelanggan</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Apa kata mereka yang sudah belanja di Dagangan UMKM?
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <Card
                key={testimonial.id}
                className="group border border-border hover:shadow-card transition-all duration-300 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-full gradient-primary flex items-center justify-center text-primary-foreground font-semibold">
                        {testimonial.name.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <p className="font-medium text-foreground">{testimonial.username || testimonial.name}</p>
                        <p className="text-xs text-muted-foreground">{testimonial.productName}</p>
                        {testimonial.productType && (
                          <p className="text-xs text-primary">{testimonial.productType}</p>
                        )}
                      </div>
                    </div>
                    <Quote className="h-6 w-6 text-primary/20" />
                  </div>

                  <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
                    {testimonial.message}
                  </p>

                  <div className="flex items-center gap-1">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-warning text-warning" />
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
